import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex items-center gap-3 text-left truncate" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "mr-3 truncate" };
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PureDropdownMenuItem',
    props: {
        icon: null,
        text: null,
        showSubMenuArrow: { type: Boolean }
    },
    emits: ['click'],
    setup(__props, { emit }) {
        function handleClick() {
            emit('click');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: "flex items-center justify-between w-full max-w-full px-4 py-2 text-sm transition-colors min-w-52 hover:bg-primary-100 dark-hover:bg-gray-550 text-primary-900 dark:text-gray-300",
                onClick: handleClick
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.icon.includes('/'))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: __props.icon,
                            class: "w-4 h-4"
                        }, null, 8, _hoisted_2))
                        : (_openBlock(), _createBlock(SvgIcon, {
                            key: 1,
                            name: __props.icon,
                            class: "w-4 h-4"
                        }, null, 8, ["name"])),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.text), 1)
                ]),
                (__props.showSubMenuArrow)
                    ? (_openBlock(), _createBlock(SvgIcon, {
                        key: 0,
                        name: "arrow-up",
                        class: "w-2 h-2 transform rotate-90"
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
